import React, { useEffect, useState } from "react";
import { backend_url } from "../../App";

const ReviewsPage = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const reviewsPerPage = 8;

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await fetch(`${backend_url}/api/customerreview`);
        const data = await res.json();

        const visibleReviews = data.filter((review) => review.showHide === true);
        setReviews(visibleReviews);
      } catch (error) {
        console.error("Error fetching reviews:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, []);

  if (loading) return <div>Loading reviews...</div>;

  if (reviews.length === 0)
    return <div className="text-center py-20">No reviews to show at the moment.</div>;

  // Calculate reviews to show on current page
  const indexOfLastReview = currentPage * reviewsPerPage;
  const indexOfFirstReview = indexOfLastReview - reviewsPerPage;
  const currentReviews = reviews.slice(indexOfFirstReview, indexOfLastReview);

  const totalPages = Math.ceil(reviews.length / reviewsPerPage);

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  return (
    <div className="max-w-7xl mx-auto p-6">
      <h1 className="text-4xl font-bold mb-12 text-center text-purple-700">
        Customer Reviews
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
        {currentReviews.map((review) => (
          <div
            key={review._id}
            className="bg-white rounded-xl shadow-lg p-6 flex flex-col"
          >
            <div className="flex items-center mb-4">
              <img crossOrigin="anonymous" 
                src={review.reviewImage}
                alt={`${review.name}'s review`}
                className="w-14 h-14 rounded-full object-cover mr-4 border-2 border-purple-500"
              />
              <div>
                <h3 className="text-lg font-semibold text-gray-900">{review.name}</h3>
                <p className="text-sm text-gray-500">{review.email}</p>
              </div>
            </div>
            <h4 className="font-semibold text-purple-700 mb-2">{review.reviewTitle}</h4>
            <p className="text-gray-700 flex-grow whitespace-pre-line">{review.review}</p>
            <div className="mt-4 text-yellow-500 font-semibold">
              ⭐ Rating: {review.rating} / 5
            </div>
          </div>
        ))}
      </div>

    {/* Pagination Controls */}
<div className="flex justify-center items-center mt-10 space-x-6">
  <button
    onClick={handlePrev}
    disabled={currentPage === 1}
    className={`px-4 py-2 rounded-md font-semibold text-lg ${
      currentPage === 1
        ? "bg-gray-300 cursor-not-allowed"
        : "bg-purple-600 text-white hover:bg-purple-700"
    }`}
    aria-label="Previous page"
  >
    ←
  </button>

  <span className="text-gray-700 font-medium">
    Page {currentPage} of {totalPages}
  </span>

  <button
    onClick={handleNext}
    disabled={currentPage === totalPages}
    className={`px-4 py-2 rounded-md font-semibold text-lg ${
      currentPage === totalPages
        ? "bg-gray-300 cursor-not-allowed"
        : "bg-purple-600 text-white hover:bg-purple-700"
    }`}
    aria-label="Next page"
  >
    →
  </button>
</div>

    </div>
  );
};

export default ReviewsPage;
